var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/img/brands/iseatu-shopping/1-search.png": "6c39",
	"./assets/img/brands/iseatu-shopping/2-customise.png": "0b29",
	"./assets/img/brands/iseatu-shopping/3-checkout.png": "36fd",
	"./assets/img/brands/iseatu-shopping/4-chat.png": "1906",
	"./assets/img/brands/iseatu-shopping/iseatu-1024-splash.png": "451e",
	"./assets/img/brands/iseatu-shopping/iseatu-1024.png": "b50b",
	"./assets/img/brands/iseatu-work/1-search.png": "8447",
	"./assets/img/brands/iseatu-work/2-choose.png": "45dc",
	"./assets/img/brands/iseatu-work/3-book-pay.png": "bcd6",
	"./assets/img/brands/iseatu-work/iseatu-1024-splash.png": "5983",
	"./assets/img/brands/iseatu-work/iseatu-1024.png": "fd0e",
	"./assets/img/brands/this-element/1-message.png": "ef0d",
	"./assets/img/brands/this-element/2-quote.png": "0f7d",
	"./assets/img/brands/this-element/3-invoice.png": "8f39",
	"./assets/img/brands/this-element/4-channels.png": "1821",
	"./assets/img/brands/this-element/Logo.Dark.WhiteBG1@2x.png": "691d",
	"./assets/img/brands/velosofi/ui-credit-card-priorities.png": "9aff",
	"./assets/img/brands/velosofi/ui-credit-card-results.png": "4cd4",
	"./assets/img/brands/velosofi/velosofi-icon.png": "7c64",
	"./assets/img/brands/velosofi/velosofi-logo-dark-gray.png": "abe7",
	"./assets/img/brands/velosofi/velosofi-white-bg-512.png": "9203",
	"./assets/img/team/al-kola.jpg": "9a41",
	"./assets/img/team/aleks-kola.jpg": "bd10",
	"./assets/img/vendor/LI-Bug.original.svg": "4310",
	"./assets/img/vendor/app-store.svg": "5884",
	"./assets/img/vendor/play-store.png": "4086",
	"./assets/logo.png": "cf05",
	"./assets/tailwind.css": "ba8c",
	"./components/AppFooter": "f657",
	"./components/AppFooter.vue": "f657",
	"./components/AppNavBar": "f3b0",
	"./components/AppNavBar.vue": "f3b0",
	"./components/HelloWorld": "fdab",
	"./components/HelloWorld.vue": "fdab",
	"./components/NotFoundPage": "e614",
	"./components/NotFoundPage.vue": "e614",
	"./components/SayHi": "39f0",
	"./components/SayHi.vue": "39f0",
	"./main": "cd49",
	"./main.ts": "cd49",
	"./router": "afbc",
	"./router/": "afbc",
	"./router/index": "afbc",
	"./router/index.ts": "afbc",
	"./shims-vue.d": "e154",
	"./shims-vue.d.ts": "e154",
	"./store": "0613",
	"./store/": "0613",
	"./store/index": "0613",
	"./store/index.ts": "0613",
	"./types/AppTypes": "9e1e",
	"./types/AppTypes.ts": "9e1e",
	"./types/Brand.interface": "943d",
	"./types/Brand.interface.ts": "943d",
	"./types/NavItem.interface": "f3f4",
	"./types/NavItem.interface.ts": "f3f4",
	"./utils/app-utils": "5fb7",
	"./utils/app-utils.ts": "5fb7",
	"./utils/brand-utils": "b2be",
	"./utils/brand-utils.ts": "b2be",
	"./views/About": "f820",
	"./views/About.vue": "f820",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/brands/BrandIseatuShoppingPage": "c7d4",
	"./views/brands/BrandIseatuShoppingPage.vue": "c7d4",
	"./views/brands/BrandIseatuWorkPage": "c9e4",
	"./views/brands/BrandIseatuWorkPage.vue": "c9e4",
	"./views/brands/BrandThisElementPage": "b63e",
	"./views/brands/BrandThisElementPage.vue": "b63e",
	"./views/brands/BrandVelosofiPage": "ca5c",
	"./views/brands/BrandVelosofiPage.vue": "ca5c",
	"./views/brands/BrandsPage": "d22b",
	"./views/brands/BrandsPage.vue": "d22b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";